import { AttachmentsSection } from "@/components/CodeGen/Chat/components/AttachmentsSection";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const searchSchema = z.object({
  tab: z.enum(["spec", "code", "preview"]).default("spec"),
  file: z.string().optional(),
});

export type AttachmentsSearchParams = z.infer<typeof searchSchema>;

export const Route = createFileRoute(
  "/(codegen)/codegen/$chatId/attachments/$versionNumber",
)({
  component: AttachmentsView,
  validateSearch: searchSchema,
});

export function AttachmentsView() {
  return <AttachmentsSection />;
}
